// Static RBAC form-access matrix (matriks Direksi RSPS). Edit by hand.

import { AccessRule } from "@/utils/form-access";

export const FORM_ACCESS_RULES: Record<string, AccessRule[]> = {
  asesmen_awal_bbl: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_gadar: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_gigi: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_keperawatan_intensif: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_ralan: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Psikolog", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_ranap: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_ranap_anak: [
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_ranap_kebidanan: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_ranap_medis: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_awal_ranap_perinatal: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_geriatri: [
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["edit", "view"] },
    { unitKategori: "gizi", profesi: "Gizi", actions: ["edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_hd: [
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_kemoterapi: [
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_populasi_khusus: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  asesmen_pra_sedasi: [
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  askeper_perioperatif: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  catatan_harian_bbl: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  catatan_kebidanan: [
    { unitKategori: "bersalin", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "view"] },
  ],
  catatan_paska_sedasi: [
    { unitKategori: "ibs", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  catatan_pra_sedasi: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  ceklis_keselamatan_op: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  ceklis_prosedur_invasif: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  checklist_persiapan_anestesi: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  checklist_screening_trombolisis: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  ceklist_alteplase: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["view"] },
  ],
  code_blue_activation: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "tim_ppi", profesi: "", actions: ["create", "edit", "report", "view"] },
  ],
  cppt: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  cppt_ralan: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Psikolog", actions: ["create", "edit", "view"] },
  ],
  discharge_planning: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gizi", profesi: "Gizi", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Gizi", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  ews_anak: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  ews_dewasa: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  general_consent_ranap: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["edit", "view"] },
  ],
  grafik_ttv_anak: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  grafik_ttv_dewasa: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  identitas_bbl: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  identitas_pasien: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  implementasi_keperawatan: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  informed_consent_tindakan: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "view"] },
  ],
  keterangan_kematian: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  klaim_ralan_rehab_medik: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "kasir", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "manajemen", profesi: "", actions: ["report", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  kriteria_keluar_intensif: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  kriteria_masuk_hcu: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  kriteria_masuk_icu: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  laporan_operasi: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  laporan_operasi_kuretase: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  laporan_operasi_kuretase_pua: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  laporan_operasi_persalinan_kuretase: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  laporan_operasi_sc: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  laporan_operasi_vaginam: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
  ],
  lembar_pemberian_obat: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  meows: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  monitoring_24jam_intensif: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  monitoring_intra_operatif: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  monitoring_kritis_igd: [
    { unitKategori: "gadar", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  monitoring_transfusi: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  monitoring_transport_eksternal: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  monitoring_trombolisis: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "hd", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "hd", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  nihss_igd: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  order_gizi_daftar_pasien: [
    { unitKategori: "gizi", profesi: "", actions: ["view"] },
  ],
  order_gizi_pemesanan: [
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "print", "view"] },
  ],
  order_gizi_rekap: [
    { unitKategori: "gizi", profesi: "", actions: ["print", "report", "view"] },
  ],
  pemantauan_anestesi: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pemantauan_pacu_rr: [
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pemantauan_terapi_gizi: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "gizi", profesi: "Gizi", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "intensif", profesi: "Gizi", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "ranap", profesi: "Gizi", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "print", "view"] },
  ],
  pemberian_informasi_tindakan: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "forensik", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pendaftaran_pasien_baru: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "kasir", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pengantar_kultur_mikrobiologi: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "lab", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "tim_ppi", profesi: "", actions: ["create", "edit", "report", "view"] },
  ],
  pengantar_masuk_hcu: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pengantar_masuk_icu: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pengantar_masuk_intensif: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pengantar_ranap_klaim: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  penggunaan_alat_reuse: [
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pengkajian_akhir_hayat: [
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pengkajian_restrain: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  penilaian_nyeri: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  permintaan_bmhp: [
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "", actions: ["create", "edit", "view"] }
  ],
  permintaan_kerohanian: [
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "view"] },
  ],
  permintaan_obat: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  permintaan_obat_kemoterapi: [
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  permintaan_second_opinion: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  pernyataan_aps: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  pernyataan_kenaikan_kelas: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "kasir", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pernyataan_kronologi: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "manajemen", profesi: "", actions: ["report", "view"] },
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  pernyataan_kronologi_hilang: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gizi", profesi: "Gizi", actions: ["create", "edit", "view"] },
    { unitKategori: "kasir", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  pernyataan_pemilihan_dokter: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  persetujuan_anestesi: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  persetujuan_dnr: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  persetujuan_penggunaan_obat: [
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  persetujuan_rawat_intensif: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  persetujuan_transfusi_darah: [
    { unitKategori: "*", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "hd", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "hd", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "kemoterapi", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "kemoterapi", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "lab", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  persetujuan_transfusi_inkompatibel: [
    { unitKategori: "*", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "hd", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "hd", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "kemoterapi", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "kemoterapi", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "lab", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  persetujuan_plebotomi: [
    { unitKategori: "*", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "hd", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "hd", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "kemoterapi", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "kemoterapi", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "lab", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  protokol_kemoterapi: [
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rekam_asuhan_hd: [
    { unitKategori: "hd", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "hd", profesi: "Perawat", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rekam_asuhan_kebidanan_gadar: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rekam_asuhan_keperawatan_gadar: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rekam_asuhan_perinatal: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rekonsiliasi_obat: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  resume_hemodialisa: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "admisi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "kasir", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  retur_obat: [
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "view"] },
  ],
  ringkasan_masuk_keluar: [
    { unitKategori: "administrasi", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "kasir", profesi: "", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  ringkasan_pulang: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  risiko_jatuh_anak: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  risiko_jatuh_dewasa: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  risiko_jatuh_igd: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  risiko_jatuh_ralan: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Psikolog", actions: ["create", "edit", "view"] },
  ],
  risiko_jatuh_ralan_tug: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Psikolog", actions: ["create", "edit", "view"] },
  ],
  rujukan_dots_hiv: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rujukan_dots_hiv_v2: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  rujukan_hiv: [
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  serah_terima_kamar_operasi: [
    { unitKategori: "bersalin", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "", actions: ["create", "edit", "print", "sign", "view"] },
  ],
  skrining_gizi_lanjut: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gizi", profesi: "Gizi", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  // Tanpa aksi "sign": blanko sumber tidak memuat blok tanda tangan.
  skrining_paliatif_anak: [
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "print", "view"] },
  ],
  // Idem — terpasang di Rawat Inap saja (Ranap > Rekam Medis > Keperawatan dan
  // Monitoring); IGD menyusul.
  skrining_paliatif_dewasa: [
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "print", "view"] },
  ],
  skrining_mpp: [
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  skrining_risiko_jatuh_ralan: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Psikolog", actions: ["create", "edit", "view"] },
  ],
  surat_konsul: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  surat_rujukan_edukasi: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "farmasi", profesi: "Farmasi", actions: ["create", "edit", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gizi", profesi: "Gizi", actions: ["create", "edit", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  surat_rujukan_ralan: [
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Psikolog", actions: ["create", "edit", "view"] },
  ],
  surat_rujukan_ranap: [
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  transfer_internal: [
    { unitKategori: "bersalin", profesi: "Bidan", actions: ["create", "edit", "view"] },
    { unitKategori: "bersalin", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ibs", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "intensif", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "intensif", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ralan", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ralan", profesi: "Perawat", actions: ["create", "edit", "view"] },
    { unitKategori: "ranap", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "ranap", profesi: "Perawat", actions: ["create", "edit", "view"] },
  ],
  visum_et_repertum: [
    { unitKategori: "forensik", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
  visum_et_repertum_igd: [
    { unitKategori: "forensik", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "gadar", profesi: "Dokter", actions: ["create", "edit", "print", "sign", "view"] },
    { unitKategori: "rekam_medis", profesi: "", actions: ["create", "edit", "view"] },
  ],
};
